import {Directive, ElementRef, Output, EventEmitter, Self, Optional, ChangeDetectorRef, Input} from "@angular/core";
import {NgControl, AbstractControl} from "@angular/forms";
import {isEmpty, groupBy, isUndefined, isString, filter, trim, findIndex, difference, uniq} from "lodash";
import {AutocompleteService} from "./autocomplete.service";
import {ModelListener} from '../model-listener';

const VALUES_SPLITTER_SHORT = ':::';
const VALUES_SPLITTER = VALUES_SPLITTER_SHORT + ' ';

const $ = require('jquery');
require('bootstrap-tokenfield');

//TODO andrey refactor directive, add ngModel support
//Directive that adds multi autocomplete to any element
@Directive({
    selector: '[multiple-autocomplete]',
    providers: [AutocompleteService]
})
export class MultipleAutocomplete extends ModelListener {

    @Output('onChange')
    onChange: EventEmitter<any> = new EventEmitter<any>();
    onTouchedCallback: EventEmitter<any> = new EventEmitter<any>();

    @Input('ac-source') source: Array<any>;
    @Input('ac-key') keyParam: string;
    @Input('ac-value') valueParam: string;
    @Input('ac-unique') unique: boolean = true;

    private valuesMap: Object;

    constructor(private el: ElementRef,
                @Optional() @Self() private formControl: NgControl,
                private cd: ChangeDetectorRef,
                private service: AutocompleteService) {
        super();
    }

    private isValueIsCorrect(value: any): boolean {
        return this.valuesMap[value] ? this.valuesMap[value][0] : undefined;
    }

    //todo andrey refactor to safe code
    //todo andrey use lodash parse value
    //todo andrey move to service
    private modifyInputAfterChanges() {
        var inputVal = this.el.nativeElement.value;
        if (isEmpty(this.valuesMap) || !isString(inputVal)) {
            return;
        }
        let inputVals: Array<string> = inputVal.split(VALUES_SPLITTER);
        if (inputVals.length > 0 && !isNaN(parseFloat(inputVals[0]))) {
            return;
        }
        let mappedVals = inputVals.map(val => this.isValueIsCorrect(trim(val))).filter(val => !isUndefined(val));
        if (!isEmpty(mappedVals)) {
            let fieldValue = mappedVals.map(mappedVal => {
                return mappedVal[this.keyParam];
            });
            this.writeValue(fieldValue);
            (<AbstractControl>this.formControl.control).setValue(fieldValue);
        } else {
            if (isUndefined(this.innerValue)) {
                return;
            }
            this.writeValue(undefined);
            (<AbstractControl>this.formControl.control).setValue(undefined);
        }
        this.cd.detectChanges();
    }

    private itemViewParser(item: any) {
        return item[this.valueParam];
    }

    ngOnInit() {
        setTimeout(() => {
            this.loadAutocomplete($, () => this.formControl.value);
        });
    }

    ngOnChange() {

    }

    private loadAutocomplete($, valReader) {
        let actualizeTokens = () => {
            const startTokens = readTokens();
            let curTokens = filter(startTokens, item => this.isValueIsCorrect(item));
            if (this.unique) {
                curTokens = uniq(curTokens);
            }
            if (curTokens && startTokens && curTokens.length === startTokens.length) {
                return;
            }
            writeTokens(curTokens);
            this.modifyInputAfterChanges();
        };

        let readTokens = () => {
            return $(this.el.nativeElement).tokenfield('getTokensList', VALUES_SPLITTER_SHORT).split(VALUES_SPLITTER);
        };

        let writeTokens = (tokens: Array<any>) => {
            $(this.el.nativeElement).tokenfield('setTokens', tokens);
        };

        let mapValuesToTokens = (values) => {
            if (!values) values = [];
            let tokens = values.map(key => {
                let idx = findIndex(this.source, sourceItem => sourceItem[this.keyParam] === key);
                return this.itemViewParser(this.source[idx]);
            });
            var curTokens = readTokens();
            if (difference(curTokens, tokens).length === 0) {
                return;
            }
            writeTokens(tokens);
            this.el.nativeElement.value = (tokens.join(VALUES_SPLITTER));
            this.modifyInputAfterChanges();
        };

        if (!$.fn.typeahead) {
            //noinspection TypeScriptUnresolvedFunction
            require('typeahead.js');
        }
        $(this.el.nativeElement).tokenfield({
            delimiter: VALUES_SPLITTER,
            typeahead: [null, {
                source: this.service.buildSuggestionEngine(
                    () => this.source,
                    item => this.itemViewParser(item),
                    () => {
                        this.valuesMap = groupBy(this.source, this.valueParam);
                    })
            }]
        }).on('tokenfield:createtoken', () => {
            setTimeout(() => this.modifyInputAfterChanges());
        }).on('tokenfield:removedtoken', () => {
            setTimeout(() => this.modifyInputAfterChanges());
        }).on('tokenfield:createdtoken', () => {
            setTimeout(() => actualizeTokens());
        }).on('tokenfield:edittoken', () => {
            setTimeout(() => actualizeTokens());
        }).data('bs.tokenfield').$input[0].onblur = () => {
            $(this.el.nativeElement).focus();
            $(this.el.nativeElement).blur();
        };
        setTimeout(() => {
            mapValuesToTokens(valReader());
            this.formControl.control.valueChanges.subscribe((val) => setTimeout(() => mapValuesToTokens(val)));
        });
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/autocomplete/multiple.autocomplete.directive.ts